
export enum Securables {
    synergist_admin = 'synergist_admin',
    impersonate = 'impersonate',
    organization_administrator = "organization_administrator",

    dashboard = "dashboard",

    //Position Management
    position = "position",
    position_create = "position_create",
    position_modify = "position_modify",
    position_delete = "position_delete",

    //Proficiency Management
    proficiency = "proficiency",
    proficiency_create = "proficiency_create",
    proficiency_modify = "proficiency_modify",
    proficiency_delete = "proficiency_delete",

    //Proficiency Group Management
    profgroup = 'profgroup',
    profgroup_create = 'profgroup_create',
    profgroup_modify = 'profgroup_modify',
    profgroup_delete = 'profgroup_delete',

    //Template Management
    template = "template",
    template_create = "template_create",
    template_modify = "template_modify",
    template_delete = "template_delete",
    template_publish = "template_publish",

    //Assessment
    assessment = "assessment",

    //Ongoing Assesment
    ongoing_assesment = "ongoing_assesment",
    ongoing_assesment_modify = "ongoing_assesment_modify",
    ongoing_assesment_publish = "ongoing_assesment_publish",

    //Talent
    talent = "talent",
    talent_create = "talent_create",
    talent_modify = "talent_modify",
    talent_delete = "talent_delete",

    //Group Management
    organization_group = "organization_group",
    organization_group_edit = "organization_group_edit",
    organization_group_delete = "organization_group_delete",
    organization_group_create = "organization_group_create",

    //Employee Access
    organization_employee = 'organization_employee',
    organization_employee_invite_create = 'organization_employee_invite_create',
    organization_employee_invite_delete = 'organization_employee_invite_delete',
    organization_employee_edit = 'organization_employee_edit',
    organization_employee_delete = 'organization_employee_delete',

    //Consultant access
    organization_consultant = 'organization_consultant',
    organization_consultant_invite_create = 'organization_consultant_invite_create',
    organization_consultant_invite_delete = 'organization_consultant_invite_delete',
    organization_consultant_edit = 'organization_consultant_edit',
    organization_consultant_delete = 'organization_consultant_delete',

    //Organization Settings
    orgsettings = "orgsettings",
    orgsettings_settings = "orgsettings_settings",
    orgsettings_assessmentperiods = "orgsettings_assessmentperiods",

    // Producer portal roles
    producer_admin = 'ProducerAdmin',
    producer = 'Producer',

    // Subscription Page
    organization_subscription = "organization_subscription",

    myaccount_access = 'myaccount_access',
    employee_portal = 'employee_portal',
}

export enum ClaimTypes {
    Roles = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
    NameIdentifier = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier",
    given_name = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
    sur_name = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname",
    emailaddress = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
    CurrentOrganizationId = 'CurrentOrganizationId',
    PortalContext = 'PortalContext',
    CurrentProducerContextId = 'CurrentProducerContextId',
    TokenExpiration = 'exp',
    ImpersonatorId = 'ImpersonatorId',
    ImpersonatorName = 'ImpersonatorName',
}

export enum SessionStorageItemIds {
    LastOrganizationId = "LastOrganizationId",
    OrganizationSettings = "OrganizationSettings", 
    ApiBasePath = "API_BASE_PATH",
    UserManagementUrl = "USER_MANAGEMENT_URL",
    SelectedProfileId = "SelectedProfileId",
    AccessToken = "AccessToken",
    InvitationId = "InvitationId",
    ClickedLogin = "ClickedLogin",
    LastPortalContext = "LastPortalContext",
    EmployeeInvitationToken = "EmployeeInvitationToken",
    ProducerInvitationId = "ProducerInvitationId",
    ProducerInvitationToken = "ProducerInvitationToken",
    LastEmployeeEmploymentId = "LastEmployeeEmploymentId",
}

export enum OrgAssociationType {
    Employee = "Employee",
    Consultant = "Consultant",
}

export enum InvitationState {
    Sent = "Sent",
    Accepted = "Accepted",
    Rejected = "Rejected"
}

export enum UpsertAction {
    Create, Update, View
}

export enum ProficiencyGroupType
{
    Custom = "Custom",
    Maintainable = "Maintainable",
    Usable = "Usable",
    Performant = "Performant",
    CultureFit = "CultureFit",
    Communication = "Communication"
}
